import { useIntl } from "react-intl";
import { sendAnalyticsInteractionEvent } from "src/analytics/sendAnalyticsEvent";
import { IconButton } from "src/design-system/components/IconButton/IconButton";
import ChevronLeft from "src/design-system/icons/ChevronLeft.svg?react";
import { useRef } from "react";
import { getHeaderHeightPadded } from "src/components/GlobalHeader/GlobalHeader";
import { useDetectSticky } from "src/utils/hooks/useDetectSticky";
import type { Kind } from "../../api/Kind";
import messages from "./PaneNav.messages";

type PaneNavProps = {
  onBackClick: () => void;
};

export type SegmentBreadcrumbProps = {
  indexInRoute?: number;
  transitKind: Kind;
};

export function PaneNav(props: Readonly<PaneNavProps>) {
  const intl = useIntl();
  const backLabel = intl.formatMessage(messages.backLabel);
  const stickyRef = useRef<HTMLDivElement>(null);
  const headerHeight = getHeaderHeightPadded();
  const { isSticky } = useDetectSticky(stickyRef, {
    rootMargin: `-${headerHeight}px 0px 0px 0px`,
  });

  return (
    <div
      className="pointer-events-none sticky top-[var(--spacing-header-height-padded)] z-10 flex items-center"
      ref={stickyRef}
    >
      {props.onBackClick && (
        <IconButton
          aria-label={backLabel}
          onClick={handleClick(props.onBackClick)}
          variant={isSticky ? "elevated" : "subtle"}
          className="pointer-events-auto pr-4 transition-[shadow,border-color,background-color] duration-200"
        >
          <ChevronLeft height={18} width={18} className="text-text-primary" />
          <span className="font-bold">{backLabel}</span>
        </IconButton>
      )}
    </div>
  );
}

function handleClick(callback: () => void) {
  return () => {
    sendAnalyticsInteractionEvent({
      category: "PaneNav",
      action: "Click:BackButton",
    });
    callback();
  };
}
